// extracted by mini-css-extract-plugin
export default {"overlay":"MC-z","bodyOpen":"NC-z","content":"OC-z","header":"PC-z","close":"QC-z","closeNoHeading":"RC-z"};